import ReorderResizeTable from './ReorderResizeTable.component';

export default ReorderResizeTable;